import { useTranslation } from 'react-i18next';

interface PersonRoleProps {
  jobTitle: string;
  company: string;
  hideCompanyName?: boolean;
  commaSeparatorEnabled?: boolean;
}

export function PersonRole({
  jobTitle,
  company,
  hideCompanyName,
  commaSeparatorEnabled,
}: PersonRoleProps) {
  const { t } = useTranslation();

  let roleDescription: string;

  if (hideCompanyName) {
    roleDescription = jobTitle;
  } else if (commaSeparatorEnabled) {
    roleDescription = `${jobTitle}, ${company}`;
  } else {
    roleDescription = t('event.speaker.roledescription', {
      0: jobTitle,
      1: company,
    });
  }

  return <div className="c-person-header-section__role">{roleDescription}</div>;
}
